/* eslint-disable tailwindcss/no-custom-classname */
import {
  BreadcrumbLink as ChakraBreadcrumbLink,
  BreadcrumbLinkProps as ChakraBreadcrumbLinkProps,
  chakra,
  forwardRef,
  useBreadcrumbStyles,
} from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export interface BreadcrumbLinkProps
  extends OmitChakraProps<ChakraBreadcrumbLinkProps> {
  isDisabled?: boolean;
}

export const BreadcrumbLink = forwardRef<BreadcrumbLinkProps, 'a'>(
  ({ isDisabled, className, href, ...props }, ref) => {
    const styles = useBreadcrumbStyles();

    // Chakra doesn't have the concept of disabling a breadcrumb link, so we
    // need to mimic the default implementation as much as possible.
    if (isDisabled) {
      return (
        <chakra.span
          aria-disabled
          className={classnames('chakra-breadcrumb__link', className)}
          __css={styles.link}
          {...props}
        />
      );
    }

    return (
      <ChakraBreadcrumbLink
        ref={ref}
        className={className}
        href={href}
        {...props}
      />
    );
  },
);
